<template>
  <div class="form-group">
    <label> {{ label }} </label>
    <BuscarSelecionar
      :id="id"
      :lista="profissionais"
      :selecionado="profissional"
      :minimo="minimo"
      @selecionar="selecionarProfissional"
      @limpar="limparProfissional"
      @recuperar="recuperarProfissionais"
    />
  </div>
</template>

<script>
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import ProfissionalServico from '@/servicos/ProfissionalServico'

const profissionalServico = new ProfissionalServico()

export default {
  name: 'BuscarSelecionarProfissional',
  components: { BuscarSelecionar },
  props: {
    label: {
      type: String,
      default: 'Profissional',
    },
    id: {
      type: String,
      default: 'profissional',
    },
    minimo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      profissional: {},
      profissionais: [],
    }
  },
  methods: {
    selecionarProfissional(profissional) {
      this.$emit('selecionadoProfissional', profissional)
    },
    limparProfissional() {
      this.profissional = {}
      this.$emit('limparProfissional')
    },
    recuperarProfissionais(filtro) {
      const data = {
        nome: filtro.palavra,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }
      profissionalServico.recuperarTodos(data).then((result) => {
        this.profissionais = result.profissionais
      })
    },
  },
}
</script>
